import { render, staticRenderFns } from "./CrowdTag.vue?vue&type=template&id=6c53983e&scoped=true&"
import script from "./CrowdTag.vue?vue&type=script&lang=js&"
export * from "./CrowdTag.vue?vue&type=script&lang=js&"
import style0 from "./CrowdTag.vue?vue&type=style&index=0&id=6c53983e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53983e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VCardText,VLazy})
